import "./fyndOverrides.css";
import "./index.css";
import { init } from "./babylonScene";
import { deleteYleElements } from "./helpers/deleteYleElements";
import { LandingPage } from "./fullscreenModals/landingPage";

const cleanUrl = () => {
  let deletedQueryString = window.location.href.split("?")[0];
  let deletedHash = deletedQueryString.split("#")[0];
  const pathName = window.location.pathname;
  return deletedHash.replace(pathName, "/");
};

const publicUrl = (language) => {
  if (language === "sve") {
    return {
      prod: "https://svenska-dataviz.ylestatic.fi/2020-12-trollets-bunker/",
      test:
        "https://svenska-dataviz.test.ylestatic.fi/2020-12-trollets-bunker/",
    };
  } else if (language === "en") {
    return {
      prod: "https://lusi-dataviz.ylestatic.fi/2021-troll-bunker/",
      test: "https://lusi-dataviz.test.ylestatic.fi/2021-troll-bunker/",
    };
  } else {
    return {
      prod: "https://lusi-dataviz.ylestatic.fi/escape_peli/",
      test: "https://lusi-dataviz.test.ylestatic.fi/escape_peli/",
    };
  }
};

window.pakopeliPublicAssetUrl =
  process.env.NODE_ENV === "production"
    ? location.href.indexOf("test.ylestatic") > -1
      ? publicUrl(process.env.LANGUAGE).test
      : publicUrl(process.env.LANGUAGE).prod
    : cleanUrl();

export const isSVTDuo = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isSvt = userAgent.indexOf("svtduo") > -1 || window.location.hash.includes("svtduo")
  return isSvt
}

const isWebView = () => {
  var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test(userAgent);
  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
      /iphone|ipod|ipad/.test(userAgent)
    );
  }

  const ios = iOS();
  if (ios) {
    document.body.classList.add("ios");
  }

  if (ios) {
    const hasValidDocumentElementRatio = [
      320 / 454, // 5, SE
      375 / 553, // 6, 7, 8
      414 / 622, // 6, 7, 8 Plus
      375 / 812, // X
      414 / 896, // Xs, Xr
    ].some(
      (ratio) =>
        ratio ===
        document.documentElement.clientWidth /
          document.documentElement.clientHeight
    );

    const snapChatOrInstagram =
      userAgent.indexOf("snapchat") > -1 || userAgent.indexOf("instagram") > -1;

    const hasSafariInUA = /Safari/.test(navigator.userAgent);
    const landscape = window.matchMedia("(orientation: landscape)").matches;
    const isiOSSafari = (hasSafariInUA && !snapChatOrInstagram) || landscape; // <- this one is set to false for webviews

    return !isiOSSafari;
  } else {
    if (userAgent.includes("wv")) {
      // Android webview
      return true;
    } else {
      // Chrome
      return false;
    }
  }
};

if (process.env.NODE_ENV === "production" && window.yleVisualisation) {
  const eventHandlers = {
    onMount: (name, element, services = {}) => {
      if (name !== appName) {
        console.log(name + " was mounted, not me.");
        return;
      }
      const parameters = services.getParameters() || {};
      startWhenDocumentReady(parameters);
    },
    //Todo: Login handlers
  };

  const appName = "pakopeli";
  // SYND OR FYND
  window.yleVisualisationEmbeds = window.yleVisualisationEmbeds || {};
  window.yleVisualisationEmbeds[appName] = eventHandlers;
} else {
  window.addEventListener("DOMContentLoaded", (event) => {
    startWhenDocumentReady();
  });
}

const startWhenDocumentReady = (parameters) => {
  deleteYleElements();
  if (
    (!isSVTDuo() && isWebView() && location.href.indexOf("test.ylestatic") < 0) ||
    window.location.hash === "#webview"
  ) {
    document.body.innerHTML = "";
    LandingPage(parameters);
  } else if (isSVTDuo()){
    parameters = {...parameters, svtDuo: true}
    startGame(parameters);
  } else {

    startGame(parameters);
  }
};

function startGame(parameters) {
  const vendorPrefix = window.pakopeliPublicAssetUrl + "vendors/"
  const scripts = [
    [
      vendorPrefix + "jquery-3.5.1.min.js",
      "sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=",
      "anonymous",
    ],
    [vendorPrefix + "babylon_42.js"],
    [vendorPrefix + "babylonjs.loaders.min.js"],
    [vendorPrefix + "babylon.gui.min.js"],
    [vendorPrefix + "pep.js"],
  ];
  let loaded = 0;

  function loadScript(src, integrity, crossOrigin) {
    let script = document.createElement("script");
    script.src = src;
//    if (integrity) script.integrity = integrity;
  //  if (crossOrigin) script.crossOrigin = crossOrigin;
  script.async = false;
    script.onload = () => {
      loaded++;
      if (loaded === scripts.length) {
        init(parameters);
      }
    };
    document?.body?.append(script);
  }

  scripts.forEach((e) => {
    const src = e[0];
    const integrity = e[1];
    const crossOrigin = e[2];
    loadScript(src, integrity, crossOrigin);
  });
}
